import React from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';

interface ITabPanelProps {
  children?: React.ReactNode;
  value: any;
  index: number;
  className: string;
}
const TabPanel: React.FC<ITabPanelProps> = (props: ITabPanelProps) => {
  const { children, value, index, className, ...other } = props;

  return (
    <div
      className={className}
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

TabPanel.displayName = 'TabPanel';

export default TabPanel;
